import styled from "styled-components";

const CardContainer = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 1.5rem;
  padding: 2.2rem 1.4rem;
  pointer-events: none; // ?
  box-shadow: var(--card-shadow);

  .wrapper {
    height: 100%;
  }

  .body-card {
    margin-top: 1.7rem;
    height: 7.1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .image-container {
    .image-bg {
    }
  }

  .counter {
    span:nth-child(1) {
      margin-right: 1rem;
    }
  }
`;

const CardLink = ({ count, name, icon, bg }) => {
  return (
    <CardContainer className={`${bg}`}>
      <div className={`wrapper`}>
        <figure className="image-container">
          <img className="image-bg" src={icon} alt="" />
        </figure>

        <div className="body-card">
          <div className="heading">
            <p className="title-white-bold-26">{name}</p>
          </div>

          <div className="counter">
            <span className="paragraph-white-reg-14">{count}</span>
            <span className="paragraph-white-reg-14">Total</span>
          </div>
        </div>
      </div>
    </CardContainer>
  );
};

export default CardLink;
